import { render } from "./card3.vue?vue&type=template&id=000af5be&scoped=true"
import script from "./card3.vue?vue&type=script&lang=ts"
export * from "./card3.vue?vue&type=script&lang=ts"

import "./card3.vue?vue&type=style&index=0&id=000af5be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-000af5be"

export default script